<ng-container [ngTemplateOutlet]="tabContent"></ng-container>